import { useId } from 'react'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import type { OptionGridProps } from './types'
import './OptionGrid.css'

/**
 * Rejilla de opciones excluyentes como botones de 52 px (bundle B2 "Selector de franja horaria",
 * B6 "Selector de tipo de petición", B8 zona/modo/atajos del clima). Radio group real; seleccionado en primary-soft.
 */
export function OptionGrid({ label, options, value, onChange, columns = 2, size = 'default', tabular, name, help, className }: OptionGridProps) {
  const uid = useId()
  const groupName = name ?? `hp-opt-${uid}`
  const labelId = `${groupName}-label`
  return (
    <fieldset className={cx('hp-optgrid', `hp-optgrid--${size}`, className)} aria-labelledby={labelId}>
      <legend id={labelId} className="hp-optgrid__legend">
        {label}
      </legend>
      <div className={cx('hp-optgrid__grid', size !== 'chip' && `hp-optgrid__grid--${columns}`)}>
        {options.map((o) => {
          const checked = o.id === value
          return (
            <label key={o.id} className={cx('hp-optgrid__option', checked && 'hp-optgrid__option--checked', o.disabled && 'hp-optgrid__option--disabled', tabular && 'tnum')}>
              <input
                type="radio"
                name={groupName}
                value={o.id}
                checked={checked}
                disabled={o.disabled}
                onChange={() => onChange(o.id)}
                className="hp-optgrid__input"
              />
              {o.icon && <Icon name={o.icon} size={size === 'chip' ? 16 : 20} />}
              <span className="hp-optgrid__label">{o.label}</span>
              {o.sublabel && <span className="hp-optgrid__sublabel tnum">{o.sublabel}</span>}
            </label>
          )
        })}
      </div>
      {help && <p className="hp-optgrid__help">{help}</p>}
    </fieldset>
  )
}
